<!-- eslint-disable vue/multi-word-component-names -->
<template lang="html">
  <button
    type="button"
    class="btn align-baseline btn-icon"
    :title="title"
  >
    <slot name="icon"><span :class="iconClass"></span></slot>
    <span class="visually-hidden"><slot>{{title}}</slot></span>
  </button>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },

    iconClass: [Array, String]
  }
};
</script>
